export default "__VITE_ASSET__DKzu31Yv__"